import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e004f332"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "action-toolbar" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("新增菜单")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("展开/折叠")
const _hoisted_7 = { class: "menu-label" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("目录")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("菜单")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("按钮")
const _hoisted_11 = { class: "icon-cell" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "action-buttons" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("目录")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("菜单")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("按钮")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-question" }, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 是否外链 ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-question" }, null, -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 路由地址 ")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-question" }, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 组件路径 ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-question" }, null, -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 权限字符 ")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-question" }, null, -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 路由参数 ")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-question" }, null, -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 是否缓存 ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("缓存")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("不缓存")
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-question" }, null, -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 显示状态 ")
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-question" }, null, -1))
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 菜单状态 ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("取 消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_IconSelect = _resolveComponent("IconSelect")!
  const _component_Search = _resolveComponent("Search")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_hasPermi = _resolveDirective("hasPermi")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_el_card, {
      class: "search-card",
      shadow: "hover"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "queryForm",
          model: $setup.queryParams,
          size: "default",
          inline: "",
          class: "search-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "菜单名称",
              prop: "menuName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: $setup.queryParams.menuName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.queryParams.menuName) = $event)),
                  placeholder: "请输入菜单名称",
                  clearable: "",
                  onKeyup: _withKeys($setup.handleQuery, ["enter"]),
                  "prefix-icon": "Search",
                  class: "search-input"
                }, null, 8, ["modelValue", "onKeyup"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "状态",
              prop: "status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: $setup.queryParams.status,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.queryParams.status) = $event)),
                  placeholder: "菜单状态",
                  clearable: "",
                  class: "search-select"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dict.type.sys_normal_disable, (dict) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: dict.value,
                        label: dict.label,
                        value: dict.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "search-buttons" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  icon: $setup.Search,
                  onClick: $setup.handleQuery,
                  class: "search-button"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["icon", "onClick"]),
                _createVNode(_component_el_button, {
                  icon: $setup.Refresh,
                  onClick: $setup.resetQuery,
                  class: "reset-button"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["icon", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 512), [
      [_vShow, $setup.showSearch]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        icon: $setup.Plus,
        onClick: $setup.handleAdd
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["icon", "onClick"])), [
        [_directive_hasPermi, ['system:menu:add']]
      ]),
      _createVNode(_component_el_button, {
        icon: $setup.Sort,
        onClick: $setup.toggleExpandAll
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["icon", "onClick"])
    ]),
    ($setup.refreshTable)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          data: $setup.menuList,
          "row-key": "menuId",
          "default-expand-all": $setup.isExpandAll,
          "tree-props": { children: 'children', hasChildren: 'hasChildren' },
          style: {"width":"100%"},
          border: "",
          stripe: "",
          "highlight-current-row": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "menuName",
              label: "菜单名称",
              "show-overflow-tooltip": true,
              "min-width": "200"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(scope.row.menuName), 1),
                (scope.row.menuType === 'M')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      size: "small",
                      type: "primary",
                      effect: "light"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }))
                  : (scope.row.menuType === 'C')
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        size: "small",
                        type: "success",
                        effect: "light"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }))
                    : (scope.row.menuType === 'F')
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 2,
                          size: "small",
                          type: "warning",
                          effect: "light"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "icon",
              label: "图标",
              align: "center",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_11, [
                  (scope.row.icon)
                    ? (_openBlock(), _createBlock(_component_svg_icon, {
                        key: 0,
                        "icon-class": scope.row.icon
                      }, null, 8, ["icon-class"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "orderNum",
              label: "排序",
              width: "80",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "perms",
              label: "权限标识",
              "show-overflow-tooltip": true
            }),
            _createVNode(_component_el_table_column, {
              prop: "component",
              label: "组件路径",
              "show-overflow-tooltip": true
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              label: "状态",
              width: "100",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_tag, {
                  type: scope.row.status === '0' ? 'success' : 'danger',
                  effect: "plain",
                  size: "small",
                  class: "status-tag"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.status === '0' ? '正常' : '停用'), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "createTime",
              label: "创建时间",
              align: "center",
              width: "160"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString($setup.parseTime(scope.row.createTime)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              align: "right",
              "min-width": "150",
              fixed: "right",
              "class-name": "action-column"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    size: "small",
                    type: "primary",
                    plain: "",
                    icon: $setup.Edit,
                    onClick: ($event: any) => ($setup.handleUpdate(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 2
                  }, 1032, ["icon", "onClick"])), [
                    [_directive_hasPermi, ['system:menu:edit']]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    size: "small",
                    type: "success",
                    plain: "",
                    icon: $setup.Plus,
                    onClick: ($event: any) => ($setup.handleAdd(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 2
                  }, 1032, ["icon", "onClick"])), [
                    [_directive_hasPermi, ['system:menu:add']]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    size: "small",
                    type: "danger",
                    plain: "",
                    icon: $setup.Delete,
                    onClick: ($event: any) => ($setup.handleDelete(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 2
                  }, 1032, ["icon", "onClick"])), [
                    [_directive_hasPermi, ['system:menu:remove']]
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "default-expand-all"])), [
          [_directive_loading, $setup.loading]
        ])
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: $setup.open,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.open) = $event)),
      title: $setup.title,
      width: "680px",
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: $setup.submitForm
        }, {
          default: _withCtx(() => [
            _hoisted_40
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, { onClick: $setup.cancel }, {
          default: _withCtx(() => [
            _hoisted_41
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: $setup.form,
          rules: $setup.rules,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "上级菜单",
                      prop: "parentId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tree_select, {
                          modelValue: $setup.form.parentId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.parentId) = $event)),
                          data: $setup.menuOptions,
                          props: $setup.treeSelectProps,
                          "node-key": "menuId",
                          placeholder: "选择上级菜单",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue", "data", "props"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "菜单类型",
                      prop: "menuType"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: $setup.form.menuType,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.menuType) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, { label: "M" }, {
                              default: _withCtx(() => [
                                _hoisted_17
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, { label: "C" }, {
                              default: _withCtx(() => [
                                _hoisted_18
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, { label: "F" }, {
                              default: _withCtx(() => [
                                _hoisted_19
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                ($setup.form.menuType != 'F')
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "菜单图标",
                          prop: "icon"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_popover, {
                              placement: "bottom-start",
                              width: "460",
                              trigger: "click",
                              onShow: $setup.showIconSelect
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: $setup.form.icon,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.icon) = $event)),
                                  placeholder: "点击选择图标",
                                  readonly: ""
                                }, {
                                  prefix: _withCtx(() => [
                                    ($setup.form.icon)
                                      ? (_openBlock(), _createBlock(_component_svg_icon, {
                                          key: 0,
                                          "icon-class": $setup.form.icon,
                                          style: {"width":"25px"}
                                        }, null, 8, ["icon-class"]))
                                      : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Search)
                                          ]),
                                          _: 1
                                        }))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_IconSelect, {
                                  ref: "iconSelectRef",
                                  onSelected: $setup.selected,
                                  "active-icon": $setup.form.icon
                                }, null, 8, ["onSelected", "active-icon"])
                              ]),
                              _: 1
                            }, 8, ["onShow"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "菜单名称",
                      prop: "menuName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: $setup.form.menuName,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.menuName) = $event)),
                          placeholder: "请输入菜单名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "显示排序",
                      prop: "orderNum"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: $setup.form.orderNum,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.orderNum) = $event)),
                          "controls-position": "right",
                          min: 0
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                ($setup.form.menuType != 'F')
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 1,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "isFrame" }, {
                          label: _withCtx(() => [
                            _createVNode(_component_el_tooltip, {
                              content: "选择是外链则路由地址需要以`http(s)://`开头",
                              placement: "top"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_20
                              ]),
                              _: 1
                            }),
                            _hoisted_21
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: $setup.form.isFrame,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.isFrame) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio, { label: "0" }, {
                                  default: _withCtx(() => [
                                    _hoisted_22
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio, { label: "1" }, {
                                  default: _withCtx(() => [
                                    _hoisted_23
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                ($setup.form.menuType != 'F')
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 2,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "path" }, {
                          label: _withCtx(() => [
                            _createVNode(_component_el_tooltip, {
                              content: "访问的路由地址，如：`user`，如外网地址需内链访问则以`http(s)://`开头",
                              placement: "top"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_24
                              ]),
                              _: 1
                            }),
                            _hoisted_25
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.form.path,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form.path) = $event)),
                              placeholder: "请输入路由地址"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                ($setup.form.menuType == 'C')
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 3,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "component" }, {
                          label: _withCtx(() => [
                            _createVNode(_component_el_tooltip, {
                              content: "访问的组件路径，如：`system/user/index`，默认在`views`目录下",
                              placement: "top"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_26
                              ]),
                              _: 1
                            }),
                            _hoisted_27
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.form.component,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.form.component) = $event)),
                              placeholder: "请输入组件路径"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                ($setup.form.menuType != 'M')
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 4,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "perms" }, {
                          label: _withCtx(() => [
                            _createVNode(_component_el_tooltip, {
                              content: "控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasPermi('system:user:list')`)",
                              placement: "top"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_28
                              ]),
                              _: 1
                            }),
                            _hoisted_29
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.form.perms,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.form.perms) = $event)),
                              placeholder: "请输入权限标识",
                              maxlength: "100"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                ($setup.form.menuType == 'C')
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 5,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "query" }, {
                          label: _withCtx(() => [
                            _createVNode(_component_el_tooltip, {
                              content: "访问路由的默认传递参数，如：{\"id\": 1, \"name\": \"ry\"}",
                              placement: "top"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_30
                              ]),
                              _: 1
                            }),
                            _hoisted_31
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.form.query,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.form.query) = $event)),
                              placeholder: "请输入路由参数",
                              maxlength: "255"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                ($setup.form.menuType == 'C')
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 6,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "isCache" }, {
                          label: _withCtx(() => [
                            _createVNode(_component_el_tooltip, {
                              content: "选择是则会被`keep-alive`缓存，需要匹配组件的`name`和地址保持一致",
                              placement: "top"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_32
                              ]),
                              _: 1
                            }),
                            _hoisted_33
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: $setup.form.isCache,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.form.isCache) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio, { label: "0" }, {
                                  default: _withCtx(() => [
                                    _hoisted_34
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio, { label: "1" }, {
                                  default: _withCtx(() => [
                                    _hoisted_35
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                ($setup.form.menuType != 'F')
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 7,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "visible" }, {
                          label: _withCtx(() => [
                            _createVNode(_component_el_tooltip, {
                              content: "选择隐藏则路由将不会出现在侧边栏，但仍然可以访问",
                              placement: "top"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_36
                              ]),
                              _: 1
                            }),
                            _hoisted_37
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: $setup.form.visible,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.form.visible) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dict.type?.sys_show_hide || [], (dict) => {
                                  return (_openBlock(), _createBlock(_component_el_radio, {
                                    key: dict.value,
                                    label: dict.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dict.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { prop: "status" }, {
                      label: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          content: "选择停用则路由将不会出现在侧边栏，也不能被访问",
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_38
                          ]),
                          _: 1
                        }),
                        _hoisted_39
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: $setup.form.status,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.form.status) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dict.type?.sys_normal_disable || [], (dict) => {
                              return (_openBlock(), _createBlock(_component_el_radio, {
                                key: dict.value,
                                label: dict.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(dict.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}